import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLoading: false,
    forgotPasswordSuccess: false,
    changePasswordSuccess: false,
    reminderType: "",
    fwaSourcePage: ""
  }
})


// WEBPACK FOOTER //
// ./src/store.js